// extracted by mini-css-extract-plugin
export var columnItem = "_eg-3";
export var columnItemDraggable = "_eg-5";
export var dragHandle = "_eg-0";
export var dragHandleHovered = "_eg-1";
export var dropdown = "_eg-6";
export var dropdownContent = "_eg-8";
export var dropdownInner = "_eg-7";
export var filterDropdownHeader = "_eg-9";
export var icon = "_eg-2";
export var moveToTopButton = "_eg-4";
export var sectionDivider = "_eg-a";